import { Button } from '@/components/ui/button';
import { Clock } from 'lucide-react';

interface TimeMachineToggleProps {
  isActive: boolean;
  onToggle: () => void;
}

export function TimeMachineToggle({ isActive, onToggle }: TimeMachineToggleProps) {
  return (
    <Button
      variant={isActive ? 'default' : 'outline'}
      size="sm"
      onClick={onToggle}
      title={isActive ? 'Time machine is active' : 'Enable time machine for historical view'}>
      <Clock className="w-4 h-4 mr-1" />
      Time Machine
    </Button>
  );
}
